import { Button } from '@mui/material';

import type { ButtonTypeMap } from '@mui/material';
import type { CSSProperties, FC, HTMLAttributes, MouseEventHandler, PropsWithChildren } from 'react';

export type SimpleButtonProps = HTMLAttributes<HTMLButtonElement> & {
	label: string;
	onClick?: MouseEventHandler;
	disabled?: boolean;
	icon?: string | React.JSX.Element;
	color?: ButtonTypeMap['props']['color'];
	size?: ButtonTypeMap['props']['size'];
	style?: CSSProperties;
	className?: string;
	variant?: ButtonTypeMap['props']['variant'];
	dataTestId: string;
	type?: 'button' | 'submit' | 'reset';
};

const SimpleButton: FC<PropsWithChildren<SimpleButtonProps>> = (
	{
		className = '',
		label = '',
		onClick = () => ({}),
		icon = '',
		disabled = false,
		style = {},
		size = 'large',
		color = 'primary',
		variant = 'contained',
		dataTestId = '',
		type = 'button',
	}: SimpleButtonProps = {} as SimpleButtonProps,
) => {
	return (
		<Button
			id={dataTestId}
			data-testid={dataTestId}
			className={className}
			type={type}
			style={{
				boxSizing: 'border-box',
				...style,
			}}
			size={size}
			disabled={disabled}
			variant={variant}
			color={color}
			onClick={onClick}
			endIcon={icon || null}
		>
			<span
				style={{
					textTransform: 'uppercase',
					...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
						? {
								fontSize: '12px',
								textTransform: 'none',
							}
						: {}),
				}}
			>
				{label}
			</span>
		</Button>
	);
};

export default SimpleButton;
